import $ from "jquery";

export const init = () => {
  let attempts = 0;

  const $body = $("body");
  const $header = $("header");
  const $bottomNav = $header.find(".header__bottom-nav");
  const $navBtn = $bottomNav.find(".toggle-btn");
  const $mainNav = $bottomNav.find(".main-nav");

  const hideMobileBottomNav = () => {
    $navBtn.removeClass("active").attr("aria-expanded", "false");
    $bottomNav.removeClass("open");
    $mainNav.slideUp(400, function () {
      $mainNav.removeClass("show").removeAttr("style");
    });
  };

  const clickOutNavMain = (e) => {
    if ($(e.target).closest($header).length) return;
    hideMobileBottomNav();
    $body.off("click", clickOutNavMain);
  };

  const setMaxHeight = () => {
    if (window.innerWidth <= 991) {
      let maxHeight = window.innerHeight;
      maxHeight = maxHeight - $header.outerHeight();
      maxHeight = maxHeight - $navBtn.outerHeight();
      $mainNav.css("max-height", maxHeight);
    } else {
      $mainNav.removeAttr("style");
    }
  };

  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      setMaxHeight();

      $navBtn.on("click", function () {
        if (this.getAttribute("aria-expanded") === "false") {
          $(this).addClass("active").attr("aria-expanded", "true");
          $mainNav.addClass("show").slideDown(400);
          $bottomNav.addClass("open");
          $body.on("click", clickOutNavMain);
        } else {
          hideMobileBottomNav();
          $body.off("click", clickOutNavMain);
        }
      });

      $(window).on("resize", setMaxHeight);
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };

  whenComplete();
};
